
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import { mask } from "vue-the-mask";

export default {
  name: "app-os-timeline",
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  directives: {
    mask,
  },
  data() {
    return {
      timelineItems: [],
      cliente: {},
      ordemServico: {},
    };
  },
  computed: {
    ...mapGetters(["pageTitle", "layoutConfig"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    goBackToOSList() {
      this.$router.push({ name: "ordensServicos" });
    },
    addTimelineItem(timeline, field, item) {
      if (!timeline[field]) {
        return;
      }

      const [date, time] = timeline[field].split(" ");

      this.timelineItems.push({
        ...item,
        date,
        time,
      });
    },
    async getInit() {
      const { id_ordem_servico } = this.$route.params;
      this.$http
        .post("/ordemservico/timeline", {
          id_ordem_servico,
        })
        .then(({ data }) => {
          const timeline = data.timeline;
          this.cliente = data.cliente;
          this.ordemServico = data.ordemServico;
          this.addTimelineItem(timeline, "dataAlteracao", {
            name: "Resposta do cliente",
            label: "Respondido",
            color: "turquoise",
            contato: timeline.contato,
            observacao: timeline.observacaoCliente,
            status: timeline.status,
          });
          this.addTimelineItem(timeline, "dataEnvioLink", {
            name: "Envio de link",
            label: "Enviado",
            color: "green",
          });
          this.addTimelineItem(timeline, "dataVisualizacao", {
            name: "Visualização",
            label: "Cliente visualizou",
            color: "orange",
          });
          this.timelineItems.sort((a, b) => {
            if (a.date === b.date) {
              return a.time < b.time ? -1 : 1;
            }

            return a.date < b.date ? -1 : 1;
          });
          this.setLoading(false);
        })
        .catch((error) => {
          this.setLoading(false);
          this.$toast.error(`Erro ao buscar timeline da OS:\n${error}`);
        });
    },
  },
  async created() {
    this.setLoading(true);
    this.getInit();
  },
};
